<template>
  <v-reports
  v-if="access.report_abs"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  ></v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "ReportsTaxes",
  data: () => ({
    headers: [
      { text: "Item name", value: "name", available: true, disabled: true },
      { text: "Items sold", value: "items_sold", available: true },
      { text: "Gross sales", value: "gross_sales", available: true },
      { text: "Net sales", value: "net_sales", available: true },
      { text: "Gross profit", value: "gross_profit", available: true },
      {
        text: "Gross profit analysis",
        value: "gross_profit_analysis",
        available: true,
        disabled: true
      },
      {
        text: "Net sales analysis",
        value: "net_sales_analysis",
        available: true,
        disabled: true
      },
      {
        text: "Gross sales analysis",
        value: "gross_sales_analysis",
        available: true,
        disabled: true
      }
    ],
    data: [],
    page: 1,
    access:null,
    numPages: 1,
    data_loading: false
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var abc = this.$communicator.then(
        this,
        await this.$communicator("abc", {
          arguments: [start_date, end_date],
          params: {
            limit: 10,
            page: this.page,
            startDate: start_date,
            endDate: end_date,
            service: params.service != "" ? params.service : '',
            employee: params.employee && params.employee._id != "" ? params.employee._id : ''
          }
        })
      );
      for (let i = 0; i < abc.length; i++) {
        abc[i].gross_profit = Math.round(abc[i].gross_profit).toLocaleString()
        abc[i].gross_sales = Math.round(abc[i].gross_sales).toLocaleString()
        abc[i].net_sales = Math.round(abc[i].net_sales).toLocaleString()
      }
      this.data = abc.slice((this.page - 1) * 10, this.page * 10);
      this.data_loading = false;
      this.numPages = Math.ceil(abc.length / 10);
    }
  },
  mounted() {
    this.headers = [
      {
        text: this.$t(`item_name`),
        value: "name",
        available: true,
        disabled: true
      },
      { text: this.$t(`items_sold`), value: "items_sold", available: true },
      { text: this.$t(`gross_sales`), value: "gross_sales", available: true },
      { text: this.$t(`net_sales`), value: "net_sales", available: true },
      { text: this.$t(`gross_profit`), value: "gross_profit", available: true },
      {
        text: this.$t(`gross_profit_analysis`),
        value: "gross_profit_analysis",
        align: 'center',
        available: true,
        disabled: true
      },
      {
        text: this.$t(`net_sales_analysis`),
        value: "net_sales_analysis",
        align: 'center',
        available: true,
        disabled: true
      },
      {
        text: this.$t(`gross_sales_analysis`),
        value: "gross_sales_analysis",
        align: 'center',
        available: true,
        disabled: true
      }
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
